import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faLayerGroup } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import { AudioPlayer } from "./AudioPlayer";
import CopyFullSOAP from "./CopyFullSOAP";
import ExportToPDF from "./ExportToPDF";
import NoteCreatedAt from "./NoteCreatedAt";
import NotesExpandableSection from "./NotesExpandableSection";
import NoteStatus from "./NoteStatus";
import { AttachmentsPreview } from "../../attachments/AttachmentsPreview";
import { SoapEditButton } from "../../common/clinical/SoapEditButton";

export default function Note({
  desc,
  note,
  user,
  patientData,
  onAudioDelete,
}) {
  if (!note) {
    return null;
  }

  const noteGroup = note?.noteGroup;

  return (
    <div className="w-full">
      <div className="flex bg-secondary rounded-t-large py-2 px-3">
        <div className="flex-1 flex flex-col items-start space-y-1">
          <div className="flex flex-row items-center space-x-2">
            {noteGroup && (
              <>
                <span
                  className="flex items-center font-medium text-base md:text-lg"
                  data-testid={`note-group-label-${note?.uuid}`}
                >
                  <FontAwesomeIcon
                    icon={faLayerGroup}
                    className="mr-1"
                  />
                  {noteGroup.name || "Grouped Note"}
                </span>
                <span>·</span>
              </>
            )}
            {note?.isMadeWithScribephone && (
              <FontAwesomeIcon
                icon={faPhone}
                className="mr-1 mb-[2px] text-[14px] text-green-500"
              />
            )}
            {note?.title && (
              <h3 className="flex font-medium text-base md:text-lg line-clamp-1">
                {note?.title}
              </h3>
            )}
            <NoteStatus note={note} />
          </div>
          <NoteCreatedAt createdAt={note?.createdAt} size="sm" />
        </div>

        <div className="flex flex-row items-center gap-3 pl-4">
          <SoapEditButton note={note} />
          <CopyFullSOAP note={note} />

          <ExportToPDF
            note={note}
            user={user}
            patient={patientData}
          />
        </div>
      </div>
      <div className="rounded-b-large bg-secondary px-3 pb-3">
        {desc ? (
          <div>
            <h5 className="text-sm py-2 text-secondary text-center">
              {desc}
            </h5>
          </div>
        ) : null}

        {!note?.isNewRecording && !note?.isMarkedAsProcessing ? (
          <NotesExpandableSection data={note} />
        ) : null}

        {note?.attachments?.length > 0 ? (
          <div className="my-2">
            <AttachmentsPreview
              attachments={note?.attachments}
              isCompactView={true}
              attachmentPreviewText="Attachments"
              emptyStateText="No files are currently attached to this note."
            />
          </div>
        ) : null}

        <div className="mt-3">
          <AudioPlayer
            note={note}
            onDelete={onAudioDelete}
            // shouldShowDeleteButton={false}
          ></AudioPlayer>
        </div>
      </div>
    </div>
  );
}
